import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { ButtonSpinner } from '../../components/ui/Loader';

type NavItem = {
  to: string;
  title: string;
  hint: string;
  icon: ReactNode;
};

function IconUsers() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M15 19.128a9.38 9.38 0 002.633.046 3.75 3.75 0 00.248-7.32C17.37 11.18 16.17 10.5 14.75 10.5c-.69 0-1.34.16-1.92.44M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
    </svg>
  );
}

function IconTx() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
    </svg>
  );
}

function IconPay() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
    </svg>
  );
}

function IconGear() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.07l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.187-.75-.126-1.076.07-.072.044-.146.087-.22.128-.332.183-.582.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.07l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.187.751.126 1.076-.07.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );
}

function IconMail() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
    </svg>
  );
}

function IconBrand() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
    </svg>
  );
}

function IconStore() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72l1.189-1.19A4.5 4.5 0 0111.25 3h1.5a4.5 4.5 0 013.232 1.34l1.189 1.19a3.004 3.004 0 01-.621 4.72" />
    </svg>
  );
}

function IconPhone() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
    </svg>
  );
}

function IconProxy() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
    </svg>
  );
}

function IconMargins() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
    </svg>
  );
}

function Chevron() {
  return (
    <svg className="w-4 h-4 text-neutral-medium opacity-60 group-hover:opacity-100 group-hover:text-brand-accent transition-opacity" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
  );
}

function RowLink({ item }: { item: NavItem }) {
  return (
    <Link
      to={item.to}
      className="tenant-row group flex items-center gap-3 sm:gap-4 px-3.5 sm:px-4 py-3.5 border-b border-white/[0.06] last:border-0 hover:bg-white/[0.03] transition-colors duration-200"
    >
      <span className="tenant-row-icon flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#121c2c] text-brand-accent border border-white/[0.06]">
        {item.icon}
      </span>
      <span className="min-w-0 flex-1 text-right">
        <span className="block text-sm sm:text-[15px] font-heading font-semibold text-neutral-light group-hover:text-brand-accent transition-colors">
          {item.title}
        </span>
        <span className="block text-xs text-neutral-medium font-body mt-0.5 truncate">{item.hint}</span>
      </span>
      <Chevron />
    </Link>
  );
}

export type TenantMerchantDashboardProps = {
  planLabel: string;
  balanceLabel: string;
  balanceLoading: boolean;
  /** Raw unified balance for threshold styling */
  balanceValue?: number | null;
  /** Human subscription expiry e.g. 12 يوم متبقي */
  expiryLabel?: string | null;
  userStats?: {
    totalUsers?: number;
    activeUsers?: number;
    bannedUsers?: number;
    adminUsers?: number;
  };
  statsLoading: boolean;
  hasNumbers: boolean;
  hasProxies: boolean;
  currentMode: string;
  maintenanceLoading: boolean;
  isUpdatingMaintenance: boolean;
  onMaintenance: (mode: 'none' | 'bot_only') => void;
  onOpenServers: () => void;
};

export function TenantMerchantDashboard({
  planLabel,
  balanceLabel,
  balanceLoading,
  balanceValue = null,
  expiryLabel = null,
  userStats,
  statsLoading,
  hasNumbers,
  hasProxies,
  currentMode,
  maintenanceLoading,
  isUpdatingMaintenance,
  onMaintenance,
  onOpenServers,
}: TenantMerchantDashboardProps) {
  const balNum = typeof balanceValue === 'number' && Number.isFinite(balanceValue) ? balanceValue : null;
  const isLow = balNum != null && balNum < 5;
  const isEmpty = balNum != null && balNum <= 0;
  const ops: NavItem[] = [
    { to: '/admin/users', title: 'المستخدمون', hint: 'إدارة وحظر وأرصدة الزبائن', icon: <IconUsers /> },
    { to: '/admin/transactions', title: 'المعاملات', hint: 'سجل الشحن والسحب والمشتريات', icon: <IconTx /> },
    {
      to: '/admin/products',
      title: 'المنتجات',
      hint: 'إضافة وإخفاء منتجات المخزن مثل الروكيت',
      icon: <IconStore />,
    },
    {
      to: '/admin/categories',
      title: 'التصنيفات',
      hint: 'تصنيفات المنتجات وإظهارها أو إخفاؤها',
      icon: <IconBrand />,
    },
    ...(hasNumbers
      ? [{ to: '/admin/numbers', title: 'الأرقام', hint: 'متابعة أرقام التجزئة', icon: <IconPhone /> } as NavItem]
      : []),
    ...(hasProxies
      ? [{ to: '/admin/proxies', title: 'البروكسيات', hint: 'متابعة بروكسيات التجزئة', icon: <IconProxy /> } as NavItem]
      : []),
    { to: '/admin/user-margins', title: 'هوامش المستخدمين', hint: 'هوامش ربح مخصصة لكل زبون', icon: <IconMargins /> },
  ];

  const settings: NavItem[] = [
    { to: '/admin/payment-gateways', title: 'بوابات الدفع', hint: 'تفعيل وإعداد طرق الدفع', icon: <IconPay /> },
    { to: '/admin/system-config', title: 'إعدادات النظام', hint: 'هوامش عامة وأسعار الصرف', icon: <IconGear /> },
    { to: '/admin/email-settings', title: 'إعدادات الإيميل', hint: 'Gmail / SMTP لرسائل التحقق', icon: <IconMail /> },
    { to: '/admin/branding', title: 'الهوية والعلامة', hint: 'الاسم والشعار ولون اللوحة', icon: <IconBrand /> },
    { to: '/admin/store-settings', title: 'إعدادات المتجر', hint: 'أسماء السيرفرات · إخفاء من البوت · ظهور الدفع', icon: <IconStore /> },
  ];

  const maintModes: { id: 'none' | 'bot_only'; label: string }[] = [
    { id: 'none', label: 'تشغيل' },
    { id: 'bot_only', label: 'صيانة البوت' },
  ];

  /** Bot is down for end-users in bot_only or comprehensive */
  const botMaintActive =
    currentMode === 'bot_only' || currentMode === 'comprehensive';
  const isModeActive = (id: 'none' | 'bot_only') =>
    id === 'none' ? !botMaintActive : botMaintActive;

  return (
    <div className="tenant-home animate-slide-up space-y-6 sm:space-y-8 pb-4">
      {/* Balance-first command strip — dominant wholesale wallet */}
      <section
        className={`tenant-wallet relative overflow-hidden rounded-2xl border px-5 py-5 sm:px-7 sm:py-6 ${
          isEmpty
            ? 'border-rose-500/35 bg-gradient-to-l from-rose-950/50 via-[#0c1522] to-[#0a1220]'
            : isLow
              ? 'border-amber-500/30 bg-gradient-to-l from-amber-950/40 via-[#0c1522] to-[#0a1220]'
              : 'border-brand-accent/25 bg-gradient-to-l from-brand-accent/10 via-[#0c1522] to-[#0a1220]'
        }`}
      >
        <div
          className="pointer-events-none absolute -left-16 -top-20 h-56 w-56 rounded-full opacity-30 blur-3xl"
          style={{
            background: isEmpty
              ? 'radial-gradient(circle, rgba(244,63,94,0.45), transparent 70%)'
              : isLow
                ? 'radial-gradient(circle, rgba(245,158,11,0.4), transparent 70%)'
                : 'radial-gradient(circle, rgba(56,189,248,0.35), transparent 70%)',
          }}
          aria-hidden
        />
        <div className="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2 mb-3">
              <p className="text-[11px] sm:text-xs font-body uppercase tracking-[0.2em] text-neutral-medium">
                رصيد الجملة
              </p>
              <span className="rounded-md border border-white/10 bg-black/25 px-2 py-0.5 text-[11px] font-body text-neutral-light">
                {planLabel}
              </span>
              {expiryLabel ? (
                <span className="rounded-md border border-white/10 bg-black/25 px-2 py-0.5 text-[11px] font-body text-neutral-medium">
                  {expiryLabel}
                </span>
              ) : null}
            </div>
            <p className="text-sm font-body text-neutral-medium mb-1">رصيد المتجر الموحّد</p>
            {balanceLoading ? (
              <div className="mt-2">
                <ButtonSpinner size="sm" />
              </div>
            ) : (
              <p
                className={`text-4xl sm:text-5xl md:text-6xl font-heading font-bold tracking-tight tabular-nums leading-none ${
                  isEmpty ? 'text-rose-300' : isLow ? 'text-amber-300' : 'text-brand-accent'
                }`}
              >
                {balanceLabel}
              </p>
            )}
            <p className="mt-3 text-xs sm:text-sm text-neutral-medium font-body max-w-xl">
              {isEmpty
                ? 'الرصيد منتهٍ — اشحن من بوت الماستر لإعادة تفعيل مشتريات زبائنك.'
                : isLow
                  ? 'الرصيد منخفض — يُفضّل الشحن قريباً حتى لا تتوقف مشتريات الزبائن.'
                  : 'يُخصم منه تلقائياً عند شراء الأرقام والبروكسيات بالجملة حسب خطتك.'}
            </p>
          </div>
          <div className="shrink-0 flex flex-col gap-2 sm:flex-row lg:flex-col">
            <div className="rounded-xl border border-white/[0.08] bg-black/30 px-4 py-3 min-w-[11rem]">
              <p className="text-[10px] uppercase tracking-wider text-neutral-medium font-body">الحالة</p>
              <p className={`mt-1 text-sm font-heading font-semibold ${isEmpty ? 'text-rose-300' : isLow ? 'text-amber-300' : 'text-emerald-300'}`}>
                {balanceLoading ? '…' : isEmpty ? 'يحتاج شحن' : isLow ? 'منخفض' : 'جاهز للبيع'}
              </p>
            </div>
            <div className="rounded-xl border border-white/[0.08] bg-black/30 px-4 py-3 min-w-[11rem]">
              <p className="text-[10px] uppercase tracking-wider text-neutral-medium font-body">مركز التحكم</p>
              <p className="mt-1 text-sm font-heading font-semibold text-neutral-light">تشغيل المتجر</p>
            </div>
          </div>
        </div>
      </section>

      {/* KPI strip — horizontal metrics, icon left of label */}
      <section className="tenant-kpi overflow-hidden rounded-2xl border border-white/[0.08] bg-[#0c1522]">
        {statsLoading ? (
          <div className="py-10 text-center">
            <ButtonSpinner />
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-y divide-white/[0.06] lg:divide-y-0 lg:divide-x lg:divide-x-reverse divide-white/[0.06]">
            {[
              { label: 'إجمالي المستخدمين', value: userStats?.totalUsers ?? 0, tone: 'text-brand-accent' },
              { label: 'نشطون', value: userStats?.activeUsers ?? 0, tone: 'text-emerald-400' },
              { label: 'محظورون', value: userStats?.bannedUsers ?? 0, tone: 'text-rose-400' },
              { label: 'أدمن', value: userStats?.adminUsers ?? 0, tone: 'text-sky-400' },
            ].map((k) => (
              <div key={k.label} className="px-4 py-4 sm:px-5 sm:py-5">
                <p className="text-[11px] sm:text-xs text-neutral-medium font-body">{k.label}</p>
                <p className={`mt-1 text-2xl sm:text-3xl font-heading font-bold tabular-nums ${k.tone}`}>
                  {k.value}
                </p>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Two-column module lists — not icon-centered cards */}
      <section className="grid grid-cols-1 xl:grid-cols-2 gap-5 sm:gap-6">
        <div className="rounded-2xl border border-white/[0.08] bg-[#0c1522] overflow-hidden">
          <div className="flex items-center justify-between px-4 sm:px-5 py-3.5 border-b border-white/[0.06]">
            <h2 className="text-sm font-heading font-semibold text-neutral-light">التشغيل اليومي</h2>
            <span className="text-[10px] uppercase tracking-wider text-neutral-medium font-body">{ops.length} أقسام</span>
          </div>
          <nav aria-label="التشغيل اليومي">
            {ops.map((item) => (
              <RowLink key={item.to} item={item} />
            ))}
          </nav>
        </div>

        <div className="rounded-2xl border border-white/[0.08] bg-[#0c1522] overflow-hidden">
          <div className="flex items-center justify-between px-4 sm:px-5 py-3.5 border-b border-white/[0.06]">
            <h2 className="text-sm font-heading font-semibold text-neutral-light">إعدادات المتجر</h2>
            <span className="text-[10px] uppercase tracking-wider text-neutral-medium font-body">{settings.length} أقسام</span>
          </div>
          <nav aria-label="إعدادات المتجر">
            {settings.map((item) => (
              <RowLink key={item.to} item={item} />
            ))}
          </nav>
        </div>
      </section>

      {/* Maintenance — segmented control + server action row */}
      <section className="rounded-2xl border border-white/[0.08] bg-[#0c1522] p-4 sm:p-5 space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h2 className="text-sm font-heading font-semibold text-neutral-light">الصيانة والسيرفرات</h2>
            <p className="text-xs text-neutral-medium font-body mt-1">
              صيانة البوت توقفه عن الزبائن فقط — الأدمن يقدر يستخدمه عادي
            </p>
          </div>
          {maintenanceLoading && <ButtonSpinner size="xs" />}
        </div>

        <div className="flex flex-wrap gap-2 p-1 rounded-xl bg-black/25 border border-white/[0.05]">
          {maintModes.map((m) => {
            const active = isModeActive(m.id);
            return (
              <button
                key={m.id}
                type="button"
                disabled={isUpdatingMaintenance}
                onClick={() => onMaintenance(m.id)}
                className={`flex-1 min-w-[4.5rem] px-3 py-2.5 rounded-lg text-xs sm:text-sm font-heading font-semibold transition-colors duration-200 ${
                  active
                    ? 'bg-brand-accent text-brand-primary shadow-sm'
                    : 'text-neutral-medium hover:text-neutral-light hover:bg-white/[0.04]'
                }`}
              >
                {m.label}
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={onOpenServers}
          className="w-full flex items-center justify-between gap-3 rounded-xl border border-rose-500/25 bg-rose-500/[0.06] px-4 py-3.5 text-right hover:bg-rose-500/10 transition-colors"
        >
          <span>
            <span className="block text-sm font-heading font-semibold text-rose-300">إخفاء / إظهار سيرفر من البوت</span>
            <span className="block text-xs text-neutral-medium font-body mt-0.5">اخفِ أي سيرفر بروكسي أو أرقام حسب خطتك — ما عاد يظهر بالبوت</span>
          </span>
          <span className="text-rose-300/80 text-lg leading-none">‹</span>
        </button>
      </section>
    </div>
  );
}
